import React from "react";
import EngineeringIcon from "./EngineeringIcons";

const AnimatedBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Floating Gears */}
      <div className="absolute top-10 left-10 animate-spin-slow">
        <EngineeringIcon type="gear" size="lg" className="text-orange-500/20" />
      </div>
      
      <div className="absolute top-20 right-20 animate-spin-slow-reverse">
        <EngineeringIcon type="cog" size="md" className="text-orange-400/15" />
      </div>
      
      <div className="absolute top-1/3 left-1/4 animate-spin-slow">
        <EngineeringIcon type="pulley" size="sm" className="text-orange-300/25" />
      </div>
      
      <div className="absolute top-1/2 right-1/3 animate-spin-slow-reverse">
        <EngineeringIcon type="gear" size="md" className="text-orange-500/20" />
      </div>
      
      <div className="absolute bottom-1/3 left-1/3 animate-spin-slow">
        <EngineeringIcon type="screw" size="sm" className="text-orange-400/15" />
      </div>
      
      <div className="absolute bottom-20 right-10 animate-spin-slow-reverse">
        <EngineeringIcon type="cog" size="lg" className="text-orange-300/25" />
      </div>
      
      <div className="absolute bottom-10 left-1/2 animate-spin-slow">
        <EngineeringIcon type="pulley" size="md" className="text-orange-500/20" />
      </div>

      {/* Floating Tools */}
      <div className="absolute top-1/4 right-1/4 animate-bounce-slow">
        <EngineeringIcon type="wrench" size="sm" className="text-orange-400/20" animated={false} />
      </div>
      
      <div className="absolute top-3/4 left-1/4 animate-bounce-slow-delayed">
        <EngineeringIcon type="hammer" size="sm" className="text-orange-300/20" animated={false} />
      </div>
      
      <div className="absolute top-1/2 left-1/2 animate-bounce-slow">
        <EngineeringIcon type="bolt" size="sm" className="text-orange-500/15" animated={false} />
      </div>

      {/* Chain Links */}
      <div className="absolute top-1/6 right-1/6 animate-pulse">
        <EngineeringIcon type="chain" size="sm" className="text-orange-400/10" animated={false} />
      </div>
      
      <div className="absolute bottom-1/6 right-1/6 animate-pulse-delayed">
        <EngineeringIcon type="chain" size="sm" className="text-orange-300/10" animated={false} />
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-orange-50/5"></div>
    </div>
  );
};

export default AnimatedBackground; 